<template>
  <button
    class="i-quiz-option"
    :class="{ selected: selected }"
    @click="$emit('select')"
  >
    <div class="dot">
      <span
        v-if="selected"
        class="dot-inner"
      ></span>
    </div>
    <span class="text">{{ text }}</span>
  </button>
</template>

<script setup>
defineProps({
  text: String,
  selected: Boolean
})
defineEmits(["select"])
</script>

<style lang="scss" scoped>
.i-quiz-option {
  display: flex;
  align-items: flex-start;
  gap: 14px;
  background: $white;
  border: 1px solid #1d4ed824;
  border-left: 4px solid $amber;
  border-radius: $radius;
  padding: 12px 14px;
  font-size: 14px;
  color: #111827d9;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  text-align: left;
  width: 100%;
  font-family: $sans;
  line-height: 1.45;
  box-shadow: 0 1px 3px #1d4ed80f;

  @include respond-to($breakpoint-sm) {
    padding: 14px 16px;
    font-size: 14px;
    gap: 12px;
  }

  @include respond-to($breakpoint-md) {
    padding: 16px 20px;
    font-size: 15px;
    gap: 14px;
  }

  &:hover {
    border-color: #1d4ed838;
    background: #1d4ed80a;
    box-shadow: 0 4px 12px #1d4ed81a;
  }

  &.selected {
    border-color: #1d4ed84d;
    border-left-color: $amber-mid;
    background: #1d4ed80f;
    color: $amber-mid;
    font-weight: 600;
    box-shadow: 0 4px 12px #1d4ed81f;

    .dot {
      border-color: $amber-mid;
      background: $amber-mid;
    }
  }

  .dot {
    width: 18px;
    height: 18px;
    min-width: 18px;
    border-radius: 50%;
    border: 2px solid #1d4ed840;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.2s ease;
    margin-top: 1px;
    flex-shrink: 0;

    @include respond-to($breakpoint-md) {
      width: 20px;
      height: 20px;
      min-width: 20px;
    }
  }

  .dot-inner {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: $white;
    display: block;
  }

  .text {
    flex: 1;
  }
}
</style>
